import { useRecursos } from "./use-recursos";
import { RecursosView } from "./view-recursos";

export function RecursosScreen() {
  const vm = useRecursos();

  return <RecursosView {...vm} />;
}

export type * from "./types-recursos";
